// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__LTETV","prevButton":"styles_prevButton__HR0Ni","nextButton":"styles_nextButton__aPKgP"};